import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import CollaborateurDashboard from "./pages/CollaborateurDashboard";
import ManagerDashboard from "./pages/ManagerDashboard";
import RHDashboard from "./pages/RHDashboard";
import RHSettings from "./pages/RHSettings";
import RHAdmin from "./pages/RHAdmin";
import MonComptePage from "./pages/MonComptePage";
import "./App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#E63946]"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect based on role
    if (user.role === "rh") return <Navigate to="/rh" replace />;
    if (user.role === "manager" || user.role === "directeur") return <Navigate to="/manager" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

const DashboardRedirect = () => {
  const { user } = useAuth();
  
  if (!user) return <Navigate to="/login" replace />;
  
  switch (user.role) {
    case "rh":
      return <Navigate to="/rh" replace />;
    case "manager":
    case "directeur":
      return <Navigate to="/manager" replace />;
    default:
      return <Navigate to="/dashboard" replace />;
  }
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<DashboardRedirect />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <CollaborateurDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manager"
            element={
              <ProtectedRoute allowedRoles={["manager", "directeur", "rh"]}>
                <ManagerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rh"
            element={
              <ProtectedRoute allowedRoles={["rh"]}>
                <RHDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rh/settings"
            element={
              <ProtectedRoute allowedRoles={["rh"]}>
                <RHSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rh/admin"
            element={
              <ProtectedRoute allowedRoles={["rh"]}>
                <RHAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mon-compte"
            element={
              <ProtectedRoute allowedRoles={["collaborateur", "manager", "directeur", "rh"]}>
                <MonComptePage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
